var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-unstyled"},[_c('li',{staticClass:"menu-title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.items),function(item){return _c('sidebar-menu-item',{key:item.name,attrs:{"data":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }